import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Checkbox, Flex, Link, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, Text } from '@abb/uikit';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FaydaModalIcon } from 'shared-components/icons/FaydaModal';
import { FaydaPointIcon } from 'shared-components/icons/FaydaPointIcon';
export const Main = (param)=>{
    let { terms, setTerms, setHowDoesItWork, data, isRegister } = param;
    const { t } = useTranslation('common');
    return /*#__PURE__*/ _jsxs(ModalContent, {
        mx: 4,
        borderRadius: "32px",
        maxW: "400px",
        children: [
            /*#__PURE__*/ _jsx(ModalCloseButton, {
                bg: "white",
                borderRadius: "50%"
            }),
            /*#__PURE__*/ _jsx(ModalHeader, {
                borderTopRadius: "32px",
                p: 0,
                bg: "rgba(87, 70, 230, 0.10)",
                w: "100%",
                children: /*#__PURE__*/ _jsx(Box, {
                    h: "200px",
                    children: /*#__PURE__*/ _jsx(FaydaModalIcon, {})
                })
            }),
            /*#__PURE__*/ _jsxs(ModalBody, {
                p: 6,
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        gap: 1,
                        alignItems: "center",
                        w: "fit-content",
                        p: "6px 8px",
                        bg: "semantic.surface.secondary",
                        borderRadius: "8px",
                        mb: 4,
                        children: [
                            /*#__PURE__*/ _jsx(FaydaPointIcon, {
                                size: "16px"
                            }),
                            /*#__PURE__*/ _jsxs(Text, {
                                fontSize: "14px",
                                children: [
                                    data === null || data === void 0 ? void 0 : data.pointInfo.pointStatistic.key,
                                    " = ",
                                    data === null || data === void 0 ? void 0 : data.pointInfo.pointStatistic.value,
                                    " AZN"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        mb: 2,
                        fontWeight: 500,
                        fontSize: "xl",
                        children: data === null || data === void 0 ? void 0 : data.pointInfo.popupDescription.key
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        mb: 4,
                        children: data === null || data === void 0 ? void 0 : data.pointInfo.popupDescription.value
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        mb: 6,
                        children: [
                            /*#__PURE__*/ _jsx(Checkbox, {
                                onChange: (e)=>setTerms({
                                        ...terms,
                                        checked: e.target.checked
                                    }),
                                isChecked: terms.checked,
                                mr: 2,
                                sx: {
                                    '&>.chakra-checkbox__control': {
                                        borderColor: 'semantic.onSurface.quaternary !important',
                                        borderWidth: '2px !important'
                                    }
                                }
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                as: "span",
                                fontSize: "sm",
                                children: /*#__PURE__*/ _jsx(Trans, {
                                    i18nKey: "loyalty.terms_approve",
                                    components: {
                                        1: /*#__PURE__*/ _jsx(Link, {
                                            color: "brand.abb.primary",
                                            onClick: ()=>setTerms({
                                                    ...terms,
                                                    isOpen: true
                                                })
                                        })
                                    }
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalFooter, {
                pb: 6,
                pt: 0,
                shadow: "none",
                gap: 3,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>setHowDoesItWork(true),
                        h: "48px",
                        w: "100%",
                        variant: "outline",
                        children: data === null || data === void 0 ? void 0 : data.generalInfo.programGuide.key
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: isRegister,
                        isDisabled: !terms.checked,
                        h: "48px",
                        w: "100%",
                        children: t('loyalty.active')
                    })
                ]
            })
        ]
    });
};
